var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "FormWrapper",
        {
          attrs: {
            title: "About you",
            body: "Provide information about yourself",
          },
        },
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return [
                    _c(
                      "form",
                      {
                        staticClass: "flex flex-col gap-2",
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return handleSubmit(_vm.updateProfileBasic)
                          },
                        },
                      },
                      [
                        _c("FormPhoto", {
                          staticClass: "mb-4",
                          attrs: { id: _vm.userId },
                          model: {
                            value: _vm.avatar,
                            callback: function ($$v) {
                              _vm.avatar = $$v
                            },
                            expression: "avatar",
                          },
                        }),
                        _c("FormGroup", {
                          attrs: {
                            title: "Email Address",
                            disabled: "",
                            value: _vm.email,
                          },
                        }),
                        _c("ValidationProvider", {
                          attrs: {
                            name: "First name",
                            rules: "required|c_name",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("FormGroup", {
                                      attrs: {
                                        title: "First Name*",
                                        placeholder: "Enter first name",
                                        errors: errors,
                                      },
                                      model: {
                                        value: _vm.givenName,
                                        callback: function ($$v) {
                                          _vm.givenName =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "givenName",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("ValidationProvider", {
                          attrs: {
                            name: "Last name",
                            rules: "required|c_name",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("FormGroup", {
                                      attrs: {
                                        title: "Last Name*",
                                        placeholder: "Enter last name",
                                        errors: errors,
                                      },
                                      model: {
                                        value: _vm.familyName,
                                        callback: function ($$v) {
                                          _vm.familyName =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "familyName",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm.companyNameShown
                          ? _c("ValidationProvider", {
                              attrs: { name: "Company name", rules: "max:160" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("FormGroup", {
                                          attrs: {
                                            title: "Company",
                                            placeholder: "Enter company name",
                                            errors: errors,
                                          },
                                          model: {
                                            value: _vm.companyName,
                                            callback: function ($$v) {
                                              _vm.companyName =
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                            },
                                            expression: "companyName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                        _c("FormGroup", {
                          staticClass: "mt-2",
                          attrs: {
                            name: "address",
                            isIcon: false,
                            type: "search",
                            title: "Address",
                            placeholder: "Enter address",
                            iconStyle: "customIcon",
                            inputClass: "fullwidthInput",
                          },
                          model: {
                            value: _vm.address,
                            callback: function ($$v) {
                              _vm.address = $$v
                            },
                            expression: "address",
                          },
                        }),
                        _c("ValidationProvider", {
                          attrs: { name: "Country", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c(
                                      "FormGroup",
                                      {
                                        attrs: {
                                          title: "Country*",
                                          errors: errors,
                                        },
                                      },
                                      [
                                        _c("ProfileCountrySelect", {
                                          model: {
                                            value: _vm.country,
                                            callback: function ($$v) {
                                              _vm.country = $$v
                                            },
                                            expression: "country",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex w-full justify-between gap-2 mt-2",
                          },
                          [
                            _c("ValidationProvider", {
                              staticClass: "mr-2 flex-1",
                              attrs: { name: "State" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("RegionInput", {
                                          attrs: {
                                            countries: _vm.country,
                                            errors: errors,
                                          },
                                          model: {
                                            value: _vm.state,
                                            callback: function ($$v) {
                                              _vm.state = $$v
                                            },
                                            expression: "state",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("FormGroup", {
                              staticClass: "flex-1",
                              attrs: {
                                name: "postal_code",
                                title: "Postal / Zip Code",
                                placeholder: "Enter postal / zip code",
                              },
                              model: {
                                value: _vm.postalCode,
                                callback: function ($$v) {
                                  _vm.postalCode = $$v
                                },
                                expression: "postalCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("ValidationProvider", {
                          attrs: {
                            name: "City",
                            rules: "required|name_with_specific_symbols",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("FormGroup", {
                                      attrs: {
                                        title: "City*",
                                        placeholder: "Enter city",
                                        errors: errors,
                                      },
                                      model: {
                                        value: _vm.city,
                                        callback: function ($$v) {
                                          _vm.city =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "city",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("ValidationProvider", {
                          attrs: { name: "Phone number", rules: "phone_us" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _vm.phoneShown
                                      ? _c(
                                          "FormGroup",
                                          {
                                            attrs: {
                                              title: "Phone number",
                                              errors: _vm.phoneTouched
                                                ? errors
                                                : [],
                                            },
                                          },
                                          [
                                            _c("TheMask", {
                                              staticClass:
                                                "form-input w-full flex-1 block px-3 py-2 rounded-md border border-gray-300 sm:text-sm sm:leading-5 focus:shadow-none outline-none focus:outline-none focus:border-primary disabled:bg-input-disabled disabled:border-gray-200 bg-inherit",
                                              class: {
                                                "border-red-300 text-red-900 placeholder-red-300 focus:border-red-300":
                                                  Boolean(
                                                    _vm.phoneTouched &&
                                                      errors.length
                                                  ),
                                              },
                                              attrs: {
                                                placeholder: "(123) 456-7890",
                                                mask: "(###) ###-####",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  _vm.phone = $event
                                                },
                                                change: function ($event) {
                                                  _vm.phoneTouched = true
                                                },
                                              },
                                              model: {
                                                value: _vm.phone,
                                                callback: function ($$v) {
                                                  _vm.phone = $$v
                                                },
                                                expression: "phone",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c(
                          "div",
                          { staticClass: "flex justify-end mt-2 pt-3" },
                          [
                            _c("UiButton", {
                              attrs: {
                                buttonText: "Save",
                                type: "submit",
                                variant: "black",
                                processing: _vm.isProcessing,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }